module.exports = __webpack_public_path__ + "static/media/Cart-Icon-White.529da16c.svg";